import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/dashboards', request)
}

export {get}
